const Differentiators = () => {
  const differentiators = [
    {
      title: 'Đội ngũ chuyên gia',
      description:
        'Dẫn dắt bởi Founder Nguyễn Ngọc Huy với hơn 24 năm kinh nghiệm và thành tích ấn tượng.',
      icon: '👨‍🏫',
      highlights: [
        '24+ năm kinh nghiệm',
        'Top 1% thu nhập cao',
        'Chứng chỉ quốc tế',
      ],
    },
    {
      title: 'Chương trình thực chiến',
      description:
        'Tập trung vào ứng dụng kiến thức vào thực tế cuộc sống và công việc.',
      icon: '🎯',
      highlights: [
        'Học qua thực hành',
        'Case study thực tế',
        'Kỹ năng ứng dụng ngay',
      ],
    },
    {
      title: 'Cộng đồng lớn mạnh',
      description:
        'Hơn 80,000 học viên đã tin tưởng và thành công cùng UPOWER.',
      icon: '👥',
      highlights: [
        '80,000+ học viên',
        'Mạng lưới rộng khắp',
        'Hỗ trợ lẫn nhau',
      ],
    },
    {
      title: 'Cam kết vì mục đích',
      description:
        'Hoạt động với sứ mệnh &ldquo;Vì Một Cộng Đồng Sống Có Mục Đích&rdquo;.',
      icon: '❤️',
      highlights: ['Sứ mệnh rõ ràng', 'Giá trị cốt lõi', 'Phục vụ cộng đồng'],
    },
    {
      title: 'Đối tác quốc tế',
      description:
        'Hợp tác cùng Blair Singer, Nick Vujicic, Lê Thẩm Dương, Hoàng Nam Tiền, Shark Hưng,... khẳng định tầm vóc quốc tế.',
      icon: '🌍',
      highlights: [
        'Diễn giả quốc tế',
        'Chương trình đẳng cấp',
        'Kiến thức tiên tiến',
      ],
    },
    {
      title: 'Phương pháp độc quyền',
      description:
        'Áp dụng các phương pháp đào tạo độc quyền được nghiên cứu và phát triển riêng cho người Việt.',
      icon: '🔬',
      highlights: [
        'Nghiên cứu khoa học',
        'Phù hợp văn hóa Việt',
        'Hiệu quả đã chứng minh',
      ],
    },
  ];

  const stats = [
    { number: '80,000+', label: 'Học viên thành công', icon: '🎓' },
    { number: '10+', label: 'Năm kinh nghiệm', icon: '⏰' },
    { number: '100+', label: 'Chương trình đào tạo', icon: '📚' },
    { number: '50+', label: 'Doanh nghiệp tin tưởng', icon: '🏢' },
  ];

  return (
    <section className="section-padding bg-white">
      <div className="container-custom">
        {/* Header */}
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            SỰ KHÁC BIỆT TẠO NÊN
          </h2>
          <p className="text-xl text-primary font-semibold mb-4">
            THÀNH CÔNG CÙNG UPOWER
          </p>
          <p className="text-lg text-gray-600 leading-relaxed">
            Những yếu tố độc đáo giúp UPOWER trở thành lựa chọn hàng đầu của
            hàng chục nghìn học viên và doanh nghiệp.
          </p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-primary to-primary-700 rounded-2xl p-6 text-white text-center hover:scale-105 transition-transform duration-300"
            >
              <div className="text-3xl mb-2">{stat.icon}</div>
              <div className="text-2xl md:text-3xl font-bold mb-2 text-secondary">
                {stat.number}
              </div>
              <div className="text-primary-100 text-sm font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>

        {/* Differentiators */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {differentiators.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 hover:border-primary/30 transition-all duration-300 hover:shadow-xl group"
            >
              <div className="text-4xl mb-6 text-center group-hover:scale-110 transition-transform duration-300">
                {item.icon}
              </div>

              <h3 className="text-xl font-bold text-gray-900 mb-4 text-center group-hover:text-primary transition-colors duration-300">
                {item.title}
              </h3>

              <p className="text-gray-600 leading-relaxed mb-6 text-center">
                {item.description}
              </p>

              <div className="space-y-2">
                {item.highlights.map((highlight, highlightIndex) => (
                  <div key={highlightIndex} className="flex items-center">
                    <svg
                      className="w-4 h-4 text-primary mr-3 flex-shrink-0"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <span className="text-gray-700 text-sm font-medium">
                      {highlight}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Testimonial Section */}
        <div className="bg-gray-50 rounded-2xl p-8 md:p-12 mb-12">
          <div className="max-w-4xl mx-auto text-center">
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8">
              Lời chứng thực từ học viên
            </h3>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div className="bg-white rounded-xl p-6 shadow-sm">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center text-white font-bold mr-4">
                    A
                  </div>
                  <div>
                    <div className="font-semibold text-gray-900">
                      Anh Minh - CEO Startup
                    </div>
                    <div className="text-sm text-gray-600">
                      Học viên khóa Leadership
                    </div>
                  </div>
                </div>
                <p className="text-gray-700 italic">
                  &ldquo;UPOWER đã thay đổi hoàn toàn cách tôi lãnh đạo đội
                  nhóm. Doanh thu công ty tăng 300% sau 6 tháng áp dụng những gì
                  học được.&rdquo;
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-sm">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center text-white font-bold mr-4">
                    L
                  </div>
                  <div>
                    <div className="font-semibold text-gray-900">
                      Chị Lan - Sales Manager
                    </div>
                    <div className="text-sm text-gray-600">
                      Học viên khóa Sales Master
                    </div>
                  </div>
                </div>
                <p className="text-gray-700 italic">
                  &ldquo;Từ một nhân viên bán hàng bình thường, tôi đã trở thành
                  Sales Manager với thu nhập gấp 5 lần nhờ những kỹ năng học
                  được tại UPOWER.&rdquo;
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-sm">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center text-white font-bold mr-4">
                    T
                  </div>
                  <div>
                    <div className="font-semibold text-gray-900">
                      Anh Tuấn - Giám đốc kinh doanh
                    </div>
                    <div className="text-sm text-gray-600">
                      Học viên khóa Coach the Coach
                    </div>
                  </div>
                </div>
                <p className="text-gray-700 italic">
                  &ldquo;Khóa học đã giúp tôi xây dựng đội nhóm mạnh mẽ và hiệu quả.
                  Doanh số của phòng ban tăng 250% chỉ trong 8 tháng.&rdquo;
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-sm">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center text-white font-bold mr-4">
                    H
                  </div>
                  <div>
                    <div className="font-semibold text-gray-900">
                      Chị Hương - Chủ doanh nghiệp
                    </div>
                    <div className="text-sm text-gray-600">
                      Học viên khóa Elite Camp
                    </div>
                  </div>
                </div>
                <p className="text-gray-700 italic">
                  &ldquo;UPOWER đã thay đổi tư duy kinh doanh của tôi hoàn toàn.
                  Công ty từ 10 nhân viên đã mở rộng thành 50 người trong 1 năm.&rdquo;
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-sm">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center text-white font-bold mr-4">
                    D
                  </div>
                  <div>
                    <div className="font-semibold text-gray-900">
                      Anh Dũng - Quản lý nhân sự
                    </div>
                    <div className="text-sm text-gray-600">
                      Học viên khóa Dragon Camp
                    </div>
                  </div>
                </div>
                <p className="text-gray-700 italic">
                  &ldquo;Những kỹ năng lãnh đạo học được tại UPOWER giúp tôi quản lý
                  đội nhóm 100+ người một cách hiệu quả và tạo động lực cho mọi người.&rdquo;
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-sm">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center text-white font-bold mr-4">
                    N
                  </div>
                  <div>
                    <div className="font-semibold text-gray-900">
                      Chị Nga - Giám đốc marketing
                    </div>
                    <div className="text-sm text-gray-600">
                      Học viên khóa Bán hàng đỉnh cao
                    </div>
                  </div>
                </div>
                <p className="text-gray-700 italic">
                  &ldquo;Phương pháp bán hàng của UPOWER thực sự hiệu quả.
                  Tôi đã đạt được mục tiêu doanh số vượt 150% kế hoạch năm.&rdquo;
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Final CTA */}
        <div className="bg-gradient-to-r from-primary to-primary-700 rounded-2xl p-8 md:p-12 text-white text-center">
          <h3 className="text-2xl md:text-3xl font-bold mb-6">
            Sẵn sàng trải nghiệm sự khác biệt?
          </h3>
          <p className="text-lg md:text-xl text-primary-100 mb-8 max-w-3xl mx-auto leading-relaxed">
            Tham gia cộng đồng 80,000+ học viên đã chọn UPOWER để thay đổi cuộc
            đời. Hành trình thành công của bạn bắt đầu từ đây!
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button
              onClick={() => {
                const element = document.querySelector('#contact-form');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="bg-white text-primary font-semibold py-3 px-8 rounded-lg hover:bg-gray-100 transition-colors duration-300"
            >
              Đăng ký khóa học ngay
            </button>
            <button
              onClick={() => {
                const element = document.querySelector('#contact-form');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="bg-transparent border-2 border-white text-white font-semibold py-3 px-8 rounded-lg hover:bg-white hover:text-primary transition-all duration-300"
            >
              Tư vấn miễn phí
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Differentiators;
